/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTreatmentQueueModel } from '../../models/patient-treatment-queue-model';

export interface PatientTreatmentQueuePatientIdQueuedGet$Params {
  patientId: string;
}

export function patientTreatmentQueuePatientIdQueuedGet(http: HttpClient, rootUrl: string, params: PatientTreatmentQueuePatientIdQueuedGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientTreatmentQueueModel>> {
  const rb = new RequestBuilder(rootUrl, patientTreatmentQueuePatientIdQueuedGet.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientTreatmentQueueModel>;
    })
  );
}

patientTreatmentQueuePatientIdQueuedGet.PATH = '/PatientTreatmentQueue/{patientId}/Queued';
